import { createSlice } from "@reduxjs/toolkit";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty";

const initialState = {
  isOpen: false,
  tableOfContents: {},
  umbrellaNode: {},
  selectedItem: {},
  activeItem: {},
};

const tableOfContentsSlice = createSlice({
  name: "tableOfContents",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
    },
    closeModal: (state, action) => {
      state.tableOfContents = {};
      state.activeItem = {};
      state.selectedItem = {};
      state.isOpen = false;
    },
    setTableOfContents: (state, action) => {
      const payload = action.payload;
      state.tableOfContents = payload;
      if (!isNullOrEmpty(payload) && !isNullOrEmpty(payload.children)) {
        state.activeItem = payload.children[0];
      }
    },
    // Atomically sets both tableOfContents and activeItem so there is never an
    // intermediate render with activeItem = children[0] when the caller knows
    // the correct active node upfront (e.g. from the URL topicfile parameter).
    setTableOfContentsAndActiveItem: (state, action) => {
      const { tocItems, activeNode } = action.payload;
      state.tableOfContents = tocItems;
      if (!isNullOrEmpty(tocItems) && !isNullOrEmpty(tocItems.children)) {
        state.activeItem = activeNode || tocItems.children[0];
      }
    },
    setSelectedMenuItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    resetSelectedMenuItem: (state, action) => {
      state.selectedItem = {};
    },
    setActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
    setUmbrellaNode: (state, action) => {
      state.umbrellaNode = action.payload;
    },
  },
});

let _tabClickTimestamp = 0;
const TAB_CLICK_LOCK_DURATION = 1500;

export const setTabClickLock = () => {
  _tabClickTimestamp = Date.now();
};

export const isTabClickLocked = () => Date.now() - _tabClickTimestamp < TAB_CLICK_LOCK_DURATION;

export const {
  closeModal,
  openModal,
  setTableOfContents,
  setTableOfContentsAndActiveItem,
  setSelectedMenuItem,
  resetSelectedMenuItem,
  setActiveItem,
  setUmbrellaNode,
} = tableOfContentsSlice.actions;

export default tableOfContentsSlice.reducer;
